import { Translation } from 'react-i18next';
export const TransText = ({children}) => {
  return (
    <Translation>{(t) => <>{t(children)}</>}</Translation>
  )
}

